import { Utils } from "utils";
import { IPlace } from "types";

const arrayKeys = [
  "category_ids",
  "additional_categories",
  "place_topics",
  "people_also_search",
  "local_business_links",
  "contacts",
];

const numberKeys = [
  "latitude",
  "longitude",
  "rating.value",
  "rating.votes_count",
];

const booleanKeys = ["is_claimed"];

const objectKeys = [
  "attributes",
  "rating_distribution",
  "work_time",
  "popular_times",
];

const stringKeys = [
  "title",
  "description",
  "category",
  "cid",
  "feature_id",
  "address",
  "address_info.borough",
  "address_info.address",
  "address_info.city",
  "address_info.zip",
  "address_info.region",
  "address_info.country_code",
  "place_id",
  "phone",
  "url",
  "domain",
  "logo",
  "main_image",
  "total_photos",
  "snippet",
  "rating.rating_type",

  "rating.rating_max",
  "time_update",
  "check_url",
];

const isNullable = (value: any) => {
  if (value === "null") return true;
  if (value === undefined) return true;
  if (value === "") return true;
  if (value === null) return true;
  return false;
};

export const convertToPlaces = async (list: any[]) => {
  try {
    const converted: IPlace[] = [];

    for (const item of list) {
      const keys = Object.keys(item);
      const data: { [key: string]: any } = {};

      for (const key of keys) {
        const value = item[key];

        if (arrayKeys.includes(key)) {
          data[key] = isNullable(value) ? [] : (JSON.parse(value) as string[]);
        }

        if (stringKeys.includes(key)) {
          data[key] = isNullable(value) ? "" : value;
        }

        if (booleanKeys.includes(key)) {
          data[key] = isNullable(value) ? false : Boolean(value);
        }

        if (numberKeys.includes(key)) {
          data[key] = isNullable(value) ? null : Number(value);
        }

        if (objectKeys.includes(key)) {
          data[key] = isNullable(value) ? null : JSON.parse(value);
        }
      }

      const place = Utils.Helpers.transpose(data) as IPlace;

      const isRatingAllowed = place.rating.value && place.rating.value >= 4;
      const isVotesAllowed =
        place.rating.votes_count && place.rating.votes_count >= 25;

      const closedStatuses = ["temporarily_closed", "closed_forever"];
      const isClosed = closedStatuses.includes(
        // @ts-ignore
        place.work_time?.work_hours.current_status
      );

      if (isRatingAllowed && isVotesAllowed && !isClosed) {
        converted.push(place);
      }
    }

    return Promise.resolve(converted);
  } catch (error) {
    return Promise.reject(error);
  }
};
